import type { O } from 'ts-toolbelt';

import { EMPTY_STRING } from '@e-socna/empty';
import type { Quantity as CompleteQuantity, UnitId } from '@e-socna/data-layer';

import { environment } from '../environment';
import type { MappedReferencesContext } from '../contexts/ReferencesContext';

import { locales } from './locales.util';

type Quantity = O.Pick<CompleteQuantity, 'value' | 'unitId'>;

export function formatQuantity(
  quantity: Quantity,
  unitsIdMap: MappedReferencesContext['unitsIdMap'],
): string {
  const unit = unitsIdMap[quantity.unitId as UnitId]?.unit;

  return `${new Intl.NumberFormat(locales['fr-FR'], {
    maximumFractionDigits: environment.quantityMaximumFractionDigits,
  }).format(quantity.value)}${unit ? ` ${unit}` : EMPTY_STRING}`;
}
